//Denne filen her ble opprettet 24.03.2025 med hensikt av å holde styr på globale variabler til Fikse.

export const suportedLanguages = ["en", "no"];
